/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminReopenMatchResponse
 */
export interface AdminReopenMatchResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminReopenMatchResponse
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminReopenMatchResponse
     */
    status: string;
    /**
     * Downstream matches whose participant slot was vacated by the reopen.
     * @type {Array<string>}
     * @memberof AdminReopenMatchResponse
     */
    vacatedMatchIds: Array<string>;
}

/**
 * Check if a given object implements the AdminReopenMatchResponse interface.
 */
export function instanceOfAdminReopenMatchResponse(value: object): value is AdminReopenMatchResponse {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('vacatedMatchIds' in value) || value['vacatedMatchIds'] === undefined) return false;
    return true;
}

export function AdminReopenMatchResponseFromJSON(json: any): AdminReopenMatchResponse {
    return AdminReopenMatchResponseFromJSONTyped(json, false);
}

export function AdminReopenMatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminReopenMatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'status': json['status'],
        'vacatedMatchIds': json['vacatedMatchIds'],
    };
}

export function AdminReopenMatchResponseToJSON(json: any): AdminReopenMatchResponse {
    return AdminReopenMatchResponseToJSONTyped(json, false);
}

export function AdminReopenMatchResponseToJSONTyped(value?: AdminReopenMatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'status': value['status'],
        'vacatedMatchIds': value['vacatedMatchIds'],
    };
}

